import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ArrowRight, RotateCcw, Headphones } from 'lucide-react';
import { useLang } from '../../context/LanguageContext';
import { useLawyahVoice } from '../../hooks/useLawyahVoice';
import { growthCopy } from '../../data/growth-copy';
import { VoicePanel } from './VoicePanel';

export const LivePlayground = () => {
  const { lang } = useLang(), copy = growthCopy[lang];
  const [scenario, setScenario] = useState('enquiry');
  const voice = useLawyahVoice(lang, { demo: true, scenario });
  return <section id="try-lawyah" className="growth-voice-section" data-testid="live-playground">
    <div className="site-container growth-voice-layout">
      <div className="growth-voice-story">
        <p className="eyebrow">{copy.demoEyebrow}</p><h2 className="growth-heading" data-testid="playground-intake-title">{copy.demoTitle}</h2>
        <p className="growth-body">{copy.demoIntro}</p>
        <div className="growth-scenarios" aria-label={copy.demoPanelLabel}>
          {copy.demoScenarios.map((item, index) => <button key={item.id} disabled={voice.active} aria-pressed={scenario === item.id} onClick={() => setScenario(item.id)} data-testid={`journey-${item.id}`}>
            <span className="growth-scenario-number">0{index + 1}</span><span><strong>{item.title}</strong><small>{item.body}</small></span><ArrowRight size={18} />
          </button>)}
        </div>
        <p className="growth-fineprint" data-testid="demo-disclosure">{copy.demoDisclosure}</p>
        <Link to="/book-demo" className="text-button" data-testid="playground-real-enquiry">{copy.demoCta}<ArrowUpRight size={17} /></Link>
      </div>
      <div className="growth-voice-console" data-testid="homepage-voice-console">
        <header className="growth-voice-header"><div><Headphones size={20} /><span data-testid="voice-demo-heading">{copy.demoPanelLabel}</span></div><button className="icon-button" onClick={voice.reset} disabled={voice.active || voice.saveStatus === 'saving' || voice.saveStatus === 'error'} aria-label={lang === 'es' ? 'Reiniciar demo' : 'Reset demo'} title={lang === 'es' ? 'Reiniciar demo' : 'Reset demo'} data-testid="demo-reset"><RotateCcw size={17} /></button></header>
        <VoicePanel voice={voice} lang={lang} demo prefix="voice-demo" />
        <footer className="growth-voice-footer"><span data-testid="demo-voice-engine">{copy.demoEngine}</span><p data-testid="demo-safety">{copy.demoFooter}</p></footer>
      </div>
    </div>
  </section>;
};